export default __webpack_public_path__ + "settings.svg";